import { Integrations } from '@sentry/tracing'
import * as Sentry from '@sentry/vue'
import 'intersection-observer'
import Vue from 'vue'
import VueMeta from 'vue-meta'
import VueMq from 'vue-mq'
import VueObserveVisibility from 'vue-observe-visibility'
import App from './App'
import { i18n } from './locales'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(VueMeta)
Vue.use(VueObserveVisibility)
Vue.use(VueMq, {
  breakpoints: {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1220,
    xxl: 1380,
    xxxl: Infinity,
  },
  defaultBreakpoint: 'sm',
})

// During pre-rendering the initial state is
// injected into the global scope, here we
// fill the store with the initial state.
if (window.__INITIAL_STATE__) store.replaceState(window.__INITIAL_STATE__)

// if sentry DSN is presented in env
if (process.env.VUE_APP_SENTRY_DSN)
  Sentry.init({
    Vue: Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: process.env.VUE_APP_SENTRY_SAMPLERATE,
    logErrors: true,
    environment:
      process.env.VUE_APP_SENTRY_ENV || process.env.NODE_ENV || 'development',
    release: process.env.VUE_APP_NAME_FULL,
  })

console.log(process.env.VUE_APP_NAME_FULL)

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
